import { render, staticRenderFns } from "./CollegeContrast.vue?vue&type=template&id=1c3151b4&scoped=true&"
import script from "./CollegeContrast.vue?vue&type=script&lang=js&"
export * from "./CollegeContrast.vue?vue&type=script&lang=js&"
import style0 from "./CollegeContrast.vue?vue&type=style&index=0&id=1c3151b4&scoped=true&lang=less&"
import style1 from "./CollegeContrast.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3151b4",
  null
  
)

export default component.exports